import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=30063f9a&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
import style1 from "./Introduction.vue?vue&type=style&index=1&id=30063f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30063f9a",
  null
  
)

export default component.exports